document.addEventListener("DOMContentLoaded", () => {
    setTimeout(initFormJS, 300)
})

function initFormJS() {
    const csrf = document.querySelector("meta[name=csrf-token]").content
    const inputTokens = document.querySelectorAll("input[name=_token]")
    inputTokens.forEach((e) => (e.value = csrf))

    const forms = document.querySelectorAll(".form.blade")
    forms.forEach((form) => {
        form.addEventListener("submit", function (e) {
            let validStatus = true
            const acceptedTerms = document.querySelector(".trainer-terms div.checkbox").classList.contains("checked")

            // Validate form elements
            form.querySelectorAll(".form-element").forEach((element) => {
                if (element.tutkitValidate && !element.tutkitValidate()) {
                    e.preventDefault()
                    validStatus = false
                }
            })

            // Validate select elements
            form.querySelectorAll("select").forEach((select) => {
                const parentDiv = select.closest(".form-element-select")
                const selectSpan = select.previousElementSibling
                const selectVal = select.value
                parentDiv.classList.remove("form-element-error")
                selectSpan.innerHTML = "Anliegen"
                if (select.required && selectVal === "Wähle dein Anliegen") {
                    parentDiv.classList.add("form-element-error")
                    selectSpan.innerHTML = "Bitte Anliegen wählen"
                }
            })

            // Validate checkboxes
            form.querySelectorAll(".blade.checkbox + input").forEach((checkboxInput) => {
                const checkboxDiv = checkboxInput.previousElementSibling
                checkboxDiv.classList.remove("checkbox-error")
                if (checkboxInput.required && checkboxInput.value !== "1") {
                    checkboxDiv.classList.add("checkbox-error")
                }
            })

            // Validate trainer types
            let typeStatus = false
            const becomeTrainerTypes = document.querySelector(".become-a-trainer-types")
            if (becomeTrainerTypes) {
                const inputValArr = Array.from(becomeTrainerTypes.querySelectorAll(".blade.checkbox + input")).map(
                    (input) => input.value
                )
                const item = inputValArr.every((val) => val === "" || val === "0")

                if (item) {
                    becomeTrainerTypes.querySelectorAll(".blade.checkbox + input").forEach((input) => {
                        input.previousElementSibling.classList.add("checkbox-error")
                    })
                    typeStatus = true
                }
            }

            // Validate custom error conditions
            form.querySelectorAll(".error.blade").forEach((validation) => {
                if (eval(JSON.parse(validation.dataset.if))) {
                    validation.style.display = "block"
                    e.preventDefault()
                } else {
                    validation.style.display = "none"
                }
            })

            // Final validation and submission
            if (validStatus && !typeStatus && acceptedTerms) {
                const submitButton = document.getElementById("button-submit-trainer-form")
                if (submitButton && !submitButton.classList.contains("button-loading")) {
                    submitButton.classList.add("button-loading")
                    document.querySelectorAll(".button-loading-outer").forEach((el) => (el.style.display = "flex"))
                }
                form.submit()
            } else {
                document.body.scrollTop = 170
                document.documentElement.scrollTop = 170
                e.preventDefault()
            }
        })
    })

    const subscribeForm = document.getElementById("subscribe-form")
    if (subscribeForm) {
        subscribeForm.addEventListener("input", () => {
            const acceptedTermsBlock = document.querySelector(".accepted_terms_block")
            if (subscribeForm.email.value.length > 0 || subscribeForm.firstname.value.length > 0) {
                acceptedTermsBlock.classList.add("visible")
            } else {
                acceptedTermsBlock.classList.remove("visible")
            }
        })
    }
}
